import { FC, ReactNode, useEffect } from 'react';
import clsx from 'clsx';

import CloseIcon from '~/shared/assets/icons/close.svg';

// import Button from '~/shared/components/ds/buttons/Button';

type ModalProps = {
  showModal: boolean;
  onClose: VoidFunction;
  showHeader?: boolean;
  title?: string | ReactNode;
  size?: 'large' | 'medium';
  className?: string;
};

const Modal: FC<ModalProps & { children: ReactNode }> = ({
  showModal,
  onClose,
  children,
  showHeader = true,
  title,
  size,
  className,
}) => {
  useEffect(() => {
    showModal ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = '');
    return () => {
      document.body.style.overflow = '';
    };
  }, [showModal]);

  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center flex overflow-x-auto px-[24px] overflow-y-auto fixed inset-0 z-100 outline-none focus:outline-none">
            <div className="relative w-full my-auto mx-auto ">
              {/* ModalRoot */}
              <div
                className={clsx(
                  'border-0 rounded-[16px] shadow-modal relative flex flex-col bg-white outline-none h-fit focus:outline-none mx-auto min-h-[120px]',
                  size === 'large' ? 'w-[1616px] min-w-[1240px] max-w-[86.25%]' : 'w-[745px]',
                  className
                )}
              >
                <button
                  className="absolute right-[15px] top-[17px] z-10"
                  onClick={onClose}
                  aria-label="Close modal"
                >
                  <CloseIcon className="w-[18px] h-[18px] fill-[#949EAC]" />
                </button>

                <div
                  className={clsx(
                    'items-start justify-between',
                    showHeader ? 'flex px-[20px] py-[16px]' : 'hidden'
                  )}
                >
                  {typeof title === 'string' ? (
                    <div className="whitespace-nowrap w-[94%]">{title}</div>
                  ) : title ? (
                    title
                  ) : null}
                </div>

                {/* Body */}
                <div className="relative flex-auto p-[20px]">{children}</div>
              </div>
            </div>
          </div>
          {/* OpaqueBackground */}
          <div
            className="fixed inset-0 z-99 bg-[##07103166] backdrop-blur-[5px]"
            aria-hidden="true"
          ></div>
        </>
      ) : null}
    </>
  );
};

export default Modal;
